// extracted by mini-css-extract-plugin
module.exports = {"group":"VideoPage_group__csqCT"};